export class SHLadderSelection {
    data: any;
    selectedCurrency: string;
    currencyIndex: number;
}
